import React from 'react';

import {findFixedFilter, fixedFilters} from '../../utils/filter-utils';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';

const CustomerRatingFilter = ({updateFilter, customerRatingFilter}) => {
  const onFilterSelect = (item, itemUnderAction, isSelected) => {
    updateFilter({range_ugc: (item.length && item[0].key) || []});
  };

  return (
    <CheckBoxList
      name="CUSTOMER RATINGS"
      data={fixedFilters.range_ugc.data}
      lookup={item => `${fixedFilters.range_ugc.name}${item.key[0]}`}
      type={fixedFilters.range_ugc.type}
      renderItem={item => (
        <>
          {item.key[0]} & above
        </>
        // <>
        //   <S.AverageReviewWrapper ratingCount={item.key[0]}>
        //     <S.AverageReviewText>{item.key[0]}+ </S.AverageReviewText>
        //   </S.AverageReviewWrapper>
        // </>
      )}
      actionHandler={onFilterSelect}
      resetHandlerProp={() => {
        updateFilter({range_ugc: []});
      }}
      defaultState={
        (customerRatingFilter &&
          customerRatingFilter.length > 0 && [
            findFixedFilter({
              target: customerRatingFilter,
              src: fixedFilters.range_ugc.data,
              type: fixedFilters.range_ugc.name,
            }),
          ]) ||
        []
      }
    />
  );
};

export default React.memo(CustomerRatingFilter);
